import { useUser } from '@/hooks/useUser';

import { Narrative } from '@/pages/PublicNarrativeAuthoring/hooks/useNarrativeById';
import { Narrative as DeprecatedNarrative } from '@/pages/Narrative/hooks/useNarrativeDeprecated';

import { AuthenticatedFollowNarrative } from './AuthenticatedFollowNarrative';
import { UnauthenticatedFollowNarrative } from './UnauthenticatedFollowNarrative';

// NOTE: temporary type union until we migrate useNarrative to gql-tada
type Props = {
  narrative: Narrative | DeprecatedNarrative;
};

export const FollowNarrative = ({ narrative }: Props) => {
  const { data: user } = useUser();

  if (user.loggedIn) {
    return <AuthenticatedFollowNarrative narrative={narrative} />;
  }

  return <UnauthenticatedFollowNarrative />;
};
